module.exports = __webpack_public_path__ + "media/images/affinity_icon_blue-51b6733a41179c510a4176342a736670.svg";